import React, { Fragment } from 'react';
import { Theme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { makeStyles } from 'tss-react/mui';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { btnHandler } from '../../helpers';
import { useLanguage } from '../../i18n';
import { toggleMenu } from '../../store/menu/action';
import './menubutton.scss';
import { useMobileBreakpointInnsyn } from '../../hooks/breakpoint';

type DispatchProps = {
    toggleMenu: () => void;
};

const useStyles = makeStyles()((theme: Theme) =>
    ({
        menuButton: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
            '&:hover': {
                backgroundColor: theme.palette.primary.main,
            },
            '&:focus': {
                outline: `2px solid ${theme.palette.primary.main}`,
                outlineOffset: '2px',
            },
        }
    }));
type Props = DispatchProps;

function _MenuButton(props: Props): React.ReactElement {
    const { classes } = useStyles();
    const menuButtonMobile = classnames(classes.menuButton, 'menu-button--mobile');
    const menuButton = classnames(classes.menuButton, 'menu-button');
    const l = useLanguage();
    const mobileScreen = useMobileBreakpointInnsyn();

    return (
        <Fragment>
            {mobileScreen ? 
                <button
                    className={menuButtonMobile}
                    onClick={btnHandler(props.toggleMenu)()}
                    aria-label={l('menu')}
                    tabIndex={3}
                >
                    <MenuIcon fontSize="large" aria-hidden={true}/>
                </button>
            :
                <div className="menu-button-wrapper">
                    <nav> 
                        <button
                            className={menuButton}
                            onClick={btnHandler(props.toggleMenu)()}
                            accessKey="3"
                            aria-haspopup={true}
                        >
                            {l('menu')}
                            <MenuIcon className="menu-icon" aria-hidden={true} />
                        </button>
                    </nav>
                </div>
            }
        </Fragment>
    );
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
    return {
        toggleMenu: () => dispatch(toggleMenu()), //toggleMenu()
    };
};

export const MenuButton = connect(null, mapDispatchToProps)(_MenuButton);
